import { frontendURL } from '../../../../helper/URLHelper';
import { ROLES } from '../../../../constants/permissions';

const SettingsWrapper = () => import('../SettingsWrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/labels'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'labels_wrapper',
          meta: {
            permissions: [...ROLES],
          },
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'labels_list',
          meta: {
            permissions: [...ROLES],
          },
          component: Index,
        },
      ],
    },
  ],
};
